import {LoadingButton} from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';
import {useSnackbar} from 'notistack';
import {useState} from 'react';

import API, {getMessagesFromApiError} from '../../../api/axios';
import {apiBaseUrl} from '../../../api/urls';
import {GasMonitoringNode} from '../../../interfaces/GasMonitoringNode';
import {CloseSnackbarAction} from '../../common/CloseSnackbarButton';
import SnackbarMessages from '../../common/SnackbarMessages';

interface Props extends Omit<DialogProps, 'onClose'> {
  item?: GasMonitoringNode;
  action: 'test_start' | 'test_stop';
  onSubmitted?: (item: GasMonitoringNode) => void;
  onClose?: () => void;
}

const AMSSensorItemTestAvaModal = ({
  item,
  action,
  onSubmitted,
  onClose,
  ...props
}: Props) => {
  const {enqueueSnackbar} = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async (pk: number) => {
    setIsSubmitting(true);
    try {
      const resp = await API.patch<GasMonitoringNode>(
        `${apiBaseUrl}/ams/${pk}/ava_test`,
        {
          enable: action === 'test_start',
        }
      );
      const message = `${action === 'test_start' ? 'Test message has been sent.' : 'AVA test has been cancelled.'}`;

      enqueueSnackbar(message, {
        variant: 'success',
        action: CloseSnackbarAction,
      });
      onSubmitted?.(resp.data);
      onClose?.();
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, "STRA_d08b8521");
      enqueueSnackbar(<SnackbarMessages messages={messages} />, {
        variant: 'error',
        action: CloseSnackbarAction,
      });
    }
    setIsSubmitting(false);
  };

  return (
    <Dialog {...props} onClose={onClose}>
      <DialogTitle>Test AVA</DialogTitle>

      <DialogContent>
        <DialogContentText>
          {`Are you sure you want to ${action === 'test_start' ? 'test' : 'cancel test of'} the selected AVA device?`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose?.()}>Cancel</Button>
        <LoadingButton
          variant="contained"
          loading={isSubmitting}
          autoFocus
          onClick={() => submit(item?.id ?? -1)}
          color="success"
        >
          {action === 'test_start' ? `Test AVA` : `Cancel Test AVA`}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default AMSSensorItemTestAvaModal;
